import { Injectable } from '@angular/core';
import { Observable, firstValueFrom, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {

  applicationEventSubscription:Observable<string>;
  applicationEventSubject:BehaviorSubject<string>;
  spinnerMessageSubscription:Observable<string>;
  spinnerMessageSubject:BehaviorSubject<string>;
  isApplicationBusy:boolean = false;

  constructor() {
    this.applicationEventSubject = new BehaviorSubject<string>('');
    this.applicationEventSubscription = this.applicationEventSubject.asObservable();
    this.spinnerMessageSubject = new BehaviorSubject<string>('');
    this.spinnerMessageSubscription = this.spinnerMessageSubject.asObservable();
  }

  showGlobalSpinner(message = ''):void {
    this.isApplicationBusy = true;
    this.spinnerMessageSubject.next(message);
    this.applicationEventSubject.next('SHOWGLOBALSPINNER');
  }

  updateGlobalSpinnerMessage(message: string):void {
    this.spinnerMessageSubject.next(message);
  }

  hideGlobalSpinner():void {
    this.isApplicationBusy = false;
    this.spinnerMessageSubject.next('');
    this.applicationEventSubject.next('HIDEGLOBALSPINNER');
  }

  playBeep() {
    const context = new (window.AudioContext || (window as any).webkitAudioContext)();
    const oscillator = context.createOscillator();
    const gainNode = context.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(1000, context.currentTime); // Frequency in Hz
    oscillator.connect(gainNode);
    gainNode.connect(context.destination);

    oscillator.start();
    oscillator.stop(context.currentTime + 0.15); // Beep duration (150ms)
  }

  
}
